<script>
  // This component acts as a slot that facets of a specific type
  // should be rendered into.
  import { facetValues } from '../store.js';
  /** @type {{facetType: any, component: any, primary: any}} */
  let { facetType = String, component } = $props();

  let facets = $derived(
    $facetValues.filter((facet) => facet.config.type === facetType)
  );
</script>

{#each facets as facet (facet.id)}
  {@const SvelteComponent = component}
  <SvelteComponent {facet} />
{/each}
